import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'components/Flex';
import Icon from 'components/Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CalendarStatus(_ref) {
  var _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'success' : _ref$status,
    translationKey = _ref.translationKey;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "xs",
    children: [/*#__PURE__*/_jsx(Icon, {
      name: "calendar",
      color: status === 'fail' ? 'alert-fail' : 'alert-success'
    }), t(translationKey)]
  });
}
export default CalendarStatus;